
// npm
import React from 'react'
import PropTypes from 'prop-types'

// react
import {HighlightableText, scopeForText} from 'components/presentation/highlightable_text'


const ScenarioText = ({text, className}) =>
{
	if (!text) { return null; }
	return <HighlightableText scope={scopeForText('s', text)} text={text} className={className}/>;
}

ScenarioText.propTypes = {
	className: PropTypes.string,
	text: PropTypes.string.isRequired
}


export {ScenarioText}
